import { useCallback } from 'react';
import likeSound from '../assets/sounds/like-click.wav';

const useClickSound = () => {
  const playClickSound = useCallback(() => {
    const audio = new Audio(likeSound);
    audio.volume = 0.2;
    audio.play().catch(err => console.log('Audio play failed:', err));
  }, []);

  return playClickSound;
};

export default useClickSound; 